// extracted by mini-css-extract-plugin
export default {"root":"CtaOne_root__7V9M7","ctaText":"CtaOne_ctaText__owKDu","btn":"CtaOne_btn__Ccjg8"};